import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep, isEqual } from "lodash";
import { updateConfig } from "@/api/configurationlist";
export default {
  props: ["deviceDid", "deviceSn", "linkOptions", "noSname"],
  data: function data() {
    return {
      dialogVisible: false,
      modeForm: {
        enabled: "",
        uplink: [],
        downlink: []
      },
      type: "",
      //标记是编辑操作还是添加操作
      // 自定义
      uplinkCustome: [],
      downlinkCustome: [],
      // 记录修改第几个
      index: 0,
      // 原始数据，用来判断数据是否被修改，若没有进行修改点击保存不向设备发送修改请求
      originMode: {}
    };
  },
  methods: {
    clearData: function clearData() {
      this.modeForm = {
        enabled: "",
        uplink: [],
        downlink: []
      };
      this.uplinkCustome = [];
      this.downlinkCustome = [];
    },
    show: function show(item, index) {
      var _this = this;

      this.clearData();

      if (item) {
        // 编辑
        this.type = "edit";
        this.modeForm.enabled = item.enabled == "1" ? true : false; // 当上下行设备变为空的时候，要显示选择框

        if (item.uplink.length === 0) {
          this.modeForm.uplink.push('');
          this.uplinkCustome.push(false);
        } else {
          item.uplink.forEach(function (uplinkItem, uplinkIndex) {
            _this.linkOptions.forEach(function (ele, index) {
              if (uplinkItem === ele.label) {
                _this.modeForm.uplink[uplinkIndex] = ele.value;
                _this.uplinkCustome[uplinkIndex] = false;
              }
            });
          });
        }

        if (item.downlink.length === 0) {
          this.modeForm.downlink.push('');
          this.downlinkCustome.push(false);
        } else {
          item.downlink.forEach(function (downlinkItem, downlinkIndex) {
            _this.linkOptions.forEach(function (ele, index) {
              if (downlinkItem === ele.label) {
                _this.modeForm.downlink[downlinkIndex] = ele.value;
                _this.downlinkCustome[downlinkIndex] = false;
              }
            });
          });
        }

        this.index = index;
      } else {
        // 增加
        this.type = "add";
        this.index = index; // 显示空的下拉框

        this.modeForm.uplink.push('');
        this.uplinkCustome.push(false);
        this.modeForm.downlink.push('');
        this.downlinkCustome.push(false);
      }

      this.dialogVisible = true;
      this.originMode = cloneDeep(this.modeForm);
    },
    // 下行设备下拉框值发生变化
    downlinkChange: function downlinkChange(val, index) {
      var _this2 = this;

      if (val == "--自定义--") {
        // 若直接用 = 赋值，不会触发DOM重新渲染
        this.$set(this.downlinkCustome, index, true);
        this.modeForm.downlink[index] = '';
        this.$nextTick(function () {
          _this2.$refs.downlink[index].focus();
        });
      } else {
        this.$set(this.downlinkCustome, index, false);
      }
    },
    uplinkChange: function uplinkChange(val, index) {
      var _this3 = this;

      if (val == "--自定义--") {
        this.$set(this.uplinkCustome, index, true);
        this.modeForm.uplink[index] = ''; // nextTick在更新后会执行，不使用nextTick会导致视图未更新focus方法出错

        this.$nextTick(function () {
          _this3.$refs.uplink[index].focus();
        });
      } else {
        this.$set(this.uplinkCustome, index, false);
      }
    },
    // 上下行设备自定义输入框失去焦点后显示下拉框
    uplinkBlur: function uplinkBlur(index) {
      this.$set(this.uplinkCustome, index, false);
    },
    downlinkBlur: function downlinkBlur(index) {
      this.$set(this.downlinkCustome, index, false);
    },
    // 添加上行设备
    addUplink: function addUplink() {
      this.modeForm.uplink.push('');
      this.uplinkCustome.push(false);
    },
    // 删除上行设备
    delUplink: function delUplink(index) {
      this.modeForm.uplink.splice(index, 1);
    },
    // 添加下行设备
    addDowlink: function addDowlink() {
      this.modeForm.downlink.push('');
      this.downlinkCustome.push(false);
    },
    // 删除下行设备
    delDownlink: function delDownlink(index) {
      this.modeForm.downlink.splice(index, 1);
    },
    updateMode: function updateMode() {
      var _this4 = this;

      // 判断是否有数据被修改
      if (!isEqual(this.modeForm, this.originMode)) {
        // 深拷贝，防止enabled值修改为数字后页面复选框直接渲染导致出错
        var copyData = cloneDeep(this.modeForm);
        copyData.enabled = copyData.enabled == true ? "1" : "";
        var action = 0;

        if (this.type === "edit") {
          action = 0;
        } else if (this.type === 'add') {
          action = 1;
        }

        var submitData = []; // 没有noSname这个字段无法修改上下行设备，只能修改是否启用

        if (this.noSname === true) {
          submitData = [{
            section: "mode",
            config: "smartlink",
            action: action,
            index: [this.index],
            // server: "smartlink",
            options: {
              enabled: copyData.enabled
            }
          }];
        } else {
          submitData = [{
            section: "mode",
            config: "smartlink",
            action: action,
            index: [this.index],
            // server: "smartlink",
            options: {
              enabled: copyData.enabled
            },
            lists: {
              'uplink': copyData.uplink,
              'downlink': copyData.downlink
            }
          }];
        }

        updateConfig(this.deviceSn, this.deviceDid, submitData).then(function (res) {
          if (res.data.data.mess === 0) {
            _this4.$message.success(_this4.$t('lang.ConfigSetting.successSetting'));

            _this4.$emit('updateData');

            _this4.dialogVisible = false;
          } else {
            _this4.$message.error(_this4.$t('lang.ConfigSetting.failSetting'));
          }
        });
      } else {
        this.dialogVisible = false;
      }
    }
  }
};